export type ConfigurationProfile = 'Default' | 'IAMPProdOnly';

export const isConfigurationProfile = (value: unknown): value is ConfigurationProfile =>
  value === 'Default' || value === 'IAMPProdOnly';

/** Profile boundaries supplement, never replace, role and feature authorization. */
export const isProfileRouteAllowed = (
  profile: ConfigurationProfile | null,
  pathname: string,
  eligibleAdminPaths: readonly string[] = [],
): boolean => {
  if (profile === null) return false;
  if (profile === 'Default') return true;
  // React Router decodes paths and matches case-insensitively. Match that behavior so encoded or
  // mixed-case "new"/"triage" segments cannot masquerade as historical record IDs.
  let path: string;
  try {
    path = decodeURIComponent(pathname).toLowerCase().replace(/\/+$/, '') || '/';
  } catch {
    return false;
  }
  if ([
    '/', '/requests', '/my-requests', '/app-consent', '/requests/new/adminconsent',
    '/requests/submitted', '/claims', '/whoami',
  ].includes(path)) return true;
  if (path === '/admin-tools') return eligibleAdminPaths.length > 0;
  if (eligibleAdminPaths.some((root) => path === root.toLowerCase() || path.startsWith(`${root.toLowerCase()}/`))) return true;
  // Submitted records remain readable/actionable even when their creation surface is unavailable.
  // Historical triagers still need the backlog; its existing team authorization remains in force.
  if (path === '/work-requests/triage') return true;
  if (/^\/requests\/(?!new$)[^/]+$/.test(path)) return true;
  return /^\/work-requests\/(?!new(?:\/|$)|triage(?:\/|$))[^/]+(?:\/artifact)?$/.test(path);
};

export const isProfileCatalogTypeAllowed = (
  profile: ConfigurationProfile | null,
  requestType: string,
): boolean => profile === 'Default' || (profile === 'IAMPProdOnly' && requestType === 'adminConsent');
